import { useLocalization } from '../../../../../../../../../../lib/hooks/useLocalization';
import { useLayoutSearchDataColumn } from '../../components/search-data';
import { Layout } from '../../lib/Layout';

export function useLayoutIdColumn() {
  const { id: title } = useLocalization().translations.unique.pages.layouts.table.columns;

  return useLayoutSearchDataColumn({
    title,
    arrangedId: Layout.ID,
    searchFieldName: 'searchById',
    filterFieldName: 'includeIds',
  });
}
